import React from 'react';
import Index from '../index';

export default function () {
  return <Index noFixedVideo noExitIntent variant="ad" />;
}
